module.exports = __webpack_public_path__ + "static/organizacja.6aa81d30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/organizacja.jpg
// module id = 703
// module chunks = 65182145508788